import { UserLoggedInNavigatorParamList } from "@/src/TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";

type WELSStackParamList = {
  WELSMain: object;
  WELSTeams: object;
  WELSLeaveReasons: object;
};

export type WidgetEmployeeLeaveSettingsStackScreenProps<
  T extends keyof WELSStackParamList,
> = {
  navigation: CompositeNavigationProp<
    NativeStackNavigationProp<UserLoggedInNavigatorParamList>,
    NativeStackNavigationProp<WELSStackParamList, T>
  >;
  route: RouteProp<WELSStackParamList, T>;
};

export const WidgetEmployeeLeaveSettingsStack =
  createNativeStackNavigator<WELSStackParamList>();
